export default __webpack_public_path__ + "b04d59d2d2e95bcfd2b6c30be59bcc7e.png";